import { render, staticRenderFns } from "./ProfileStep1.vue?vue&type=template&id=4474223b&scoped=true&"
import script from "./ProfileStep1.vue?vue&type=script&lang=js&"
export * from "./ProfileStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474223b",
  null
  
)

export default component.exports